import EmployeeModel from "./EmployeeModel";
import ServiceJobModel from "./ServiceJobModel";
import OrderJobAssigneeModel from "./OrderJobAssigneeModel";
import OrderModel from "./OrderModel";

export default class OrderJobModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970, 0, 1);
			this.estimationHrs = data.estimationHrs ?? 0;
			this.discountPercent = data.discountPercent ?? 0;
			this.overriddenJobCostPerHour = data.overriddenJobCostPerHour ?? null;
			
			if (data.order?.id) {
				this.order = new OrderModel(data.order);
			}

			if (data.serviceJob?.id) {
				this.serviceJob = new ServiceJobModel(data.serviceJob);
			}

			if (data.manager?.id) {
				this.manager = new EmployeeModel(data.manager);
			}

			if (data.assignees?.length) {
				this.assignees = data.assignees.map((_: any) => new OrderJobAssigneeModel(_));
			}
			
			if (data.jobOrder) {				
				this.jobOrder = data.jobOrder;
			}

			if (data.isSubcontract === true) {
				this.isSubcontract = true;
			}

			this.notes = data.notes;
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);
	discountPercent = 0;
	overriddenJobCostPerHour: number | null = null;
	order: OrderModel | null = null;
	serviceJob: ServiceJobModel | null = null;
	manager: EmployeeModel | null = null;
	estimationHrs: number = 0;
	assignees: Array<OrderJobAssigneeModel> | null = null;	
	jobOrder = 0;
	isSubcontract = false;
	notes: string | null = null;
}